export class ListDataCatalogsFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "catalogType",
            "baseName": "catalogType",
            "type": "DataCatalogTypeFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogsFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
